import { Icon } from '../utils/icons';

const MetricCard = ({ title, value, icon, description, trend }) => {
    return (
        <div className="bg-white rounded-2xl border border-gray-100 p-6 hover:shadow-lg transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                    <div className="w-12 h-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl flex items-center justify-center text-blue-600 text-xl">
                        {icon}
                    </div>
                    <div className="ml-4">
                        <h3 className="text-sm font-medium text-gray-600">{title}</h3>
                        <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
                    </div>
                </div>
                {trend && (
                    <div className={`flex items-center text-sm ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`}>
                        <Icon name={trend.isPositive ? 'trendingUp' : 'trendingDown'} size={16} />
                        <span className="ml-1">{trend.value}%</span>
                    </div>
                )}
            </div>
            {description && (
                <p className="text-sm text-gray-500">{description}</p>
            )}
        </div>
    );
};

const DashboardMetrics = ({ data, isLoading }) => {
    if (isLoading) {
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="bg-white rounded-2xl border border-gray-100 p-6 animate-pulse">
                        <div className="flex items-center">
                            <div className="w-12 h-12 bg-gray-200 rounded-xl"></div>
                            <div className="ml-4 flex-1">
                                <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
                                <div className="h-6 bg-gray-200 rounded w-16"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    const metrics = [
        {
            title: "Total Locations",
            value: data?.totalLocations || 0,
            icon: <Icon name="location" size={24} className="text-blue-600" />,
            description: "Business locations added"
        },
        {
            title: "Total Reviews",
            value: data?.totalReviews || 0,
            icon: <Icon name="star" size={24} className="text-blue-600" />,
            description: "Reviews across all platforms"
        },
        {
            title: "Active Widgets",
            value: data?.totalWidgets || 0,
            icon: <Icon name="widgets" size={24} className="text-blue-600" />,
            description: "Widgets created and deployed"
        },
        {
            title: "Total Visitors",
            value: data?.totalVisitors || 0,
            icon: <Icon name="people" size={24} className="text-blue-600" />,
            description: "Unique visitors to all widgets"
        }
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
            {metrics.map((metric, index) => (
                <MetricCard
                    key={index}
                    title={metric.title}
                    value={metric.value.toLocaleString()}
                    icon={metric.icon}
                    description={metric.description}
                />
            ))}
        </div>
    );
};

export default DashboardMetrics;
